export const bancos = [
    {
        "ISPB": 0,
        "Nome_Reduzido": "BCO DO BRASIL S.A.",
        "Numero_Codigo": "001",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco do Brasil S.A.                                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 208,
        "Nome_Reduzido": "BRB - BCO DE BRASILIA S.A.",
        "Numero_Codigo": "070",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BRB - BANCO DE BRASILIA S.A.                                                    ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 38121,
        "Nome_Reduzido": "Selic                              ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Central do Brasil - Selic                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 38166,
        "Nome_Reduzido": "Bacen                              ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Central do Brasil                                                         ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 250699,
        "Nome_Reduzido": "AGK CC S.A.",
        "Numero_Codigo": "272",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "AGK CORRETORA DE CAMBIO S.A.                                                    ",
        "Início_da_Operação": "21/11/2018"
    },
    {
        "ISPB": 315557,
        "Nome_Reduzido": "UNICRED",
        "Numero_Codigo": "136",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. - UNICRED DO BRASI",
        "Início_da_Operação": "28/07/2014"
    },
    {
        "ISPB": 360305,
        "Nome_Reduzido": "CAIXA ECONOMICA FEDERAL",
        "Numero_Codigo": "104",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CAIXA ECONOMICA FEDERAL                                                         ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 394460,
        "Nome_Reduzido": "STN                                ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Secretaria do Tesouro Nacional - STN                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 416968,
        "Nome_Reduzido": "BANCO INTER",
        "Numero_Codigo": "077",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Inter S.A.                                                                ",
        "Início_da_Operação": "15/08/2008"
    },
    {
        "ISPB": 517645,
        "Nome_Reduzido": "BCO RIBEIRAO PRETO S.A.",
        "Numero_Codigo": "741",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO RIBEIRAO PRETO S.A.                                                       ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 556603,
        "Nome_Reduzido": "BANCO BARI S.A.",
        "Numero_Codigo": "330",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.                               ",
        "Início_da_Operação": "22/07/2019"
    },
    {
        "ISPB": 558456,
        "Nome_Reduzido": "BCO CETELEM S.A.",
        "Numero_Codigo": "739",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Cetelem S.A.                                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 795423,
        "Nome_Reduzido": "BANCO SEMEAR",
        "Numero_Codigo": "743",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Semear S.A.                                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 806535,
        "Nome_Reduzido": "PLANNER CV S.A.",
        "Numero_Codigo": "100",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Planner Corretora de Valores S.A.                                               ",
        "Início_da_Operação": "27/04/2011"
    },
    {
        "ISPB": 997185,
        "Nome_Reduzido": "BCO B3 S.A.",
        "Numero_Codigo": "096",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco B3 S.A.                                                                   ",
        "Início_da_Operação": "12/11/2004"
    },
    {
        "ISPB": 1023570,
        "Nome_Reduzido": "BCO RABOBANK INTL BRASIL S.A.",
        "Numero_Codigo": "747",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Rabobank International Brasil S.A.                                        ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 1027058,
        "Nome_Reduzido": "CIELO S.A.",
        "Numero_Codigo": "362",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CIELO S.A.                                                                      ",
        "Início_da_Operação": "17/07/2020"
    },
    {
        "ISPB": 1073966,
        "Nome_Reduzido": "CCR DE ABELARDO LUZ",
        "Numero_Codigo": "322",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Cooperativa de Crédito Rural de Abelardo Luz - Sulcredi/Crediluz                ",
        "Início_da_Operação": "14/06/2019"
    },
    {
        "ISPB": 1181521,
        "Nome_Reduzido": "BCO COOPERATIVO SICREDI S.A.",
        "Numero_Codigo": "748",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO COOPERATIVO SICREDI S.A.                                                  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 1330387,
        "Nome_Reduzido": "CREHNOR LARANJEIRAS",
        "Numero_Codigo": "350",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE",
        "Início_da_Operação": "27/05/2020"
    },
    {
        "ISPB": 1522368,
        "Nome_Reduzido": "BCO BNP PARIBAS BRASIL S A",
        "Numero_Codigo": "752",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco BNP Paribas Brasil S.A.                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 1634601,
        "Nome_Reduzido": "CCCM UNICRED CENTRAL RS",
        "Numero_Codigo": "091",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S",
        "Início_da_Operação": "22/11/2010"
    },
    {
        "ISPB": 1701201,
        "Nome_Reduzido": "KIRTON BANK",
        "Numero_Codigo": "399",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Kirton Bank S.A. - Banco Múltiplo                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 1800019,
        "Nome_Reduzido": "PORTOCRED S.A. - CFI",
        "Numero_Codigo": "108",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PORTOCRED S.A. - CREDITO, FINANCIAMENTO E INVESTIMENTO                          ",
        "Início_da_Operação": "03/11/2011"
    },
    {
        "ISPB": 2038232,
        "Nome_Reduzido": "BANCOOB",
        "Numero_Codigo": "756",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO COOPERATIVO DO BRASIL S.A. - BANCOOB                                      ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 2276653,
        "Nome_Reduzido": "TRINUS CAPITAL DTVM",
        "Numero_Codigo": "360",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.              ",
        "Início_da_Operação": "16/07/2020"
    },
    {
        "ISPB": 2318507,
        "Nome_Reduzido": "BCO KEB HANA DO BRASIL S.A.",
        "Numero_Codigo": "757",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO KEB HANA DO BRASIL S.A.                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 2332886,
        "Nome_Reduzido": "XP INVESTIMENTOS CCTVM S/A",
        "Numero_Codigo": "102",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "XP INVESTIMENTOS CORRETORA DE CÂMBIO,TÍTULOS E VALORES MOBILIÁRIOS S/A          ",
        "Início_da_Operação": "22/11/2011"
    },
    {
        "ISPB": 2398976,
        "Nome_Reduzido": "UNIPRIME NORTE DO PARANÁ - CC",
        "Numero_Codigo": "084",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "UNIPRIME NORTE DO PARANÁ - COOPERATIVA DE CRÉDITO LTDA                          ",
        "Início_da_Operação": "24/11/2009"
    },
    {
        "ISPB": 2685483,
        "Nome_Reduzido": "CM CAPITAL MARKETS CCTVM LTDA",
        "Numero_Codigo": "180",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA      ",
        "Início_da_Operação": "20/01/2017"
    },
    {
        "ISPB": 2801938,
        "Nome_Reduzido": "BCO MORGAN STANLEY S.A.",
        "Numero_Codigo": "066",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO MORGAN STANLEY S.A.                                                       ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 2819125,
        "Nome_Reduzido": "UBS BRASIL CCTVM S.A.",
        "Numero_Codigo": "015",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.              ",
        "Início_da_Operação": "15/03/2011"
    },
    {
        "ISPB": 2992317,
        "Nome_Reduzido": "TREVISO CC S.A.",
        "Numero_Codigo": "143",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Treviso Corretora de Câmbio S.A.                                                ",
        "Início_da_Operação": "24/08/2015"
    },
    {
        "ISPB": 2992335,
        "Nome_Reduzido": "CIP Siloc                          ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Câmara Interbancária de Pagamentos - CIP - LDL                                  ",
        "Início_da_Operação": "13/02/2004"
    },
    {
        "ISPB": 3012230,
        "Nome_Reduzido": "HIPERCARD BM S.A.",
        "Numero_Codigo": "062",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Hipercard Banco Múltiplo S.A.                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 3017677,
        "Nome_Reduzido": "BCO. J.SAFRA S.A.",
        "Numero_Codigo": "074",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco J. Safra S.A.                                                             ",
        "Início_da_Operação": "26/08/2004"
    },
    {
        "ISPB": 3046391,
        "Nome_Reduzido": "UNIPRIME CENTRAL CCC LTDA.",
        "Numero_Codigo": "099",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "UNIPRIME CENTRAL - CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.       ",
        "Início_da_Operação": "11/01/2011"
    },
    {
        "ISPB": 3215790,
        "Nome_Reduzido": "BCO TOYOTA DO BRASIL S.A.",
        "Numero_Codigo": "387",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Toyota do Brasil S.A.                                                     ",
        "Início_da_Operação": "21/07/2020"
    },
    {
        "ISPB": 3311443,
        "Nome_Reduzido": "PARATI - CFI S.A.",
        "Numero_Codigo": "326",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PARATI - CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.                             ",
        "Início_da_Operação": "07/01/2020"
    },
    {
        "ISPB": 3323840,
        "Nome_Reduzido": "BCO ALFA S.A.",
        "Numero_Codigo": "025",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Alfa S.A.                                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 3502968,
        "Nome_Reduzido": "PI DTVM S.A.",
        "Numero_Codigo": "315",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PI Distribuidora de Títulos e Valores Mobiliários S.A.                          ",
        "Início_da_Operação": "24/01/2019"
    },
    {
        "ISPB": 3532415,
        "Nome_Reduzido": "BCO ABN AMRO S.A.",
        "Numero_Codigo": "075",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco ABN Amro S.A.                                                             ",
        "Início_da_Operação": "11/11/2005"
    },
    {
        "ISPB": 3609817,
        "Nome_Reduzido": "BCO CARGILL S.A.",
        "Numero_Codigo": "040",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Cargill S.A.                                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 3751794,
        "Nome_Reduzido": "TERRA INVESTIMENTOS DTVM",
        "Numero_Codigo": "307",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.        ",
        "Início_da_Operação": "25/10/2018"
    },
    {
        "ISPB": 3973814,
        "Nome_Reduzido": "SERVICOOP",
        "Numero_Codigo": "190",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "SERVICOOP - COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN",
        "Início_da_Operação": "16/10/2017"
    },
    {
        "ISPB": 4062902,
        "Nome_Reduzido": "VISION S.A. CC",
        "Numero_Codigo": "296",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "VISION S.A. CORRETORA DE CAMBIO                                                 ",
        "Início_da_Operação": "11/02/2019"
    },
    {
        "ISPB": 4184779,
        "Nome_Reduzido": "BANCO BRADESCARD",
        "Numero_Codigo": "063",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bradescard S.A.                                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 4257795,
        "Nome_Reduzido": "NOVA FUTURA CTVM LTDA.",
        "Numero_Codigo": "191",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.                    ",
        "Início_da_Operação": "22/06/2017"
    },
    {
        "ISPB": 4307598,
        "Nome_Reduzido": "FIDUCIA SCMEPP LTDA",
        "Numero_Codigo": "382",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L",
        "Início_da_Operação": "31/07/2020"
    },
    {
        "ISPB": 4332281,
        "Nome_Reduzido": "GOLDMAN SACHS DO BRASIL BM S.A",
        "Numero_Codigo": "064",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.                                     ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 4391007,
        "Nome_Reduzido": "CIP Sitraf                         ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Câmara Interbancária de Pagamentos                                              ",
        "Início_da_Operação": "27/11/2002"
    },
    {
        "ISPB": 4632856,
        "Nome_Reduzido": "CREDISIS CENTRAL DE COOPERATIVAS DE CRÉDITO LTDA.",
        "Numero_Codigo": "097",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Credisis - Central de Cooperativas de Crédito Ltda.                             ",
        "Início_da_Operação": "08/02/2011"
    },
    {
        "ISPB": 4715685,
        "Nome_Reduzido": "SICOOB CREDITRAN",
        "Numero_Codigo": "016",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI",
        "Início_da_Operação": "08/05/2012"
    },
    {
        "ISPB": 4814563,
        "Nome_Reduzido": "SOROCRED CFI S.A.",
        "Numero_Codigo": "299",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "SOROCRED   CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.                           ",
        "Início_da_Operação": "03/12/2018"
    },
    {
        "ISPB": 4866275,
        "Nome_Reduzido": "BANCO INBURSA",
        "Numero_Codigo": "012",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Inbursa S.A.                                                              ",
        "Início_da_Operação": "04/05/2017"
    },
    {
        "ISPB": 4902979,
        "Nome_Reduzido": "BCO DA AMAZONIA S.A.",
        "Numero_Codigo": "003",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO DA AMAZONIA S.A.                                                          ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 4913129,
        "Nome_Reduzido": "CONFIDENCE CC S.A.",
        "Numero_Codigo": "060",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Confidence Corretora de Câmbio S.A.                                             ",
        "Início_da_Operação": "21/09/2010"
    },
    {
        "ISPB": 4913711,
        "Nome_Reduzido": "BCO DO EST. DO PA S.A.",
        "Numero_Codigo": "037",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco do Estado do Pará S.A.                                                    ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 5351887,
        "Nome_Reduzido": "ZEMA CFI S/A",
        "Numero_Codigo": "359",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "ZEMA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A                                  ",
        "Início_da_Operação": "10/06/2020"
    },
    {
        "ISPB": 5442029,
        "Nome_Reduzido": "CASA CREDITO S.A. SCM",
        "Numero_Codigo": "159",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor                  ",
        "Início_da_Operação": "04/09/2017"
    },
    {
        "ISPB": 5463212,
        "Nome_Reduzido": "COOP CENTRAL AILOS",
        "Numero_Codigo": "085",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Cooperativa Central de Crédito - Ailos                                          ",
        "Início_da_Operação": "17/05/2010"
    },
    {
        "ISPB": 5790149,
        "Nome_Reduzido": "CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO",
        "Numero_Codigo": "114",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Central Cooperativa de Crédito no Estado do Espírito Santo - CECOOP             ",
        "Início_da_Operação": "27/10/2011"
    },
    {
        "ISPB": 6271464,
        "Nome_Reduzido": "BCO BBI S.A.",
        "Numero_Codigo": "036",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bradesco BBI S.A.                                                         ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 7207996,
        "Nome_Reduzido": "BCO BRADESCO FINANC. S.A.",
        "Numero_Codigo": "394",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bradesco Financiamentos S.A.                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 7237373,
        "Nome_Reduzido": "BCO DO NORDESTE DO BRASIL S.A.",
        "Numero_Codigo": "004",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco do Nordeste do Brasil S.A.                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 7450604,
        "Nome_Reduzido": "BCO CCB BRASIL S.A.",
        "Numero_Codigo": "320",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "China Construction Bank (Brasil) Banco Múltiplo S/A                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 7512441,
        "Nome_Reduzido": "HS FINANCEIRA",
        "Numero_Codigo": "189",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "HS FINANCEIRA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS                        ",
        "Início_da_Operação": "05/06/2017"
    },
    {
        "ISPB": 7652226,
        "Nome_Reduzido": "LECCA CFI S.A.",
        "Numero_Codigo": "105",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Lecca Crédito, Financiamento e Investimento S/A                                 ",
        "Início_da_Operação": "27/12/2011"
    },
    {
        "ISPB": 7656500,
        "Nome_Reduzido": "BCO KDB BRASIL S.A.",
        "Numero_Codigo": "076",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco KDB do Brasil S.A.                                                        ",
        "Início_da_Operação": "10/04/2006"
    },
    {
        "ISPB": 7679404,
        "Nome_Reduzido": "BANCO TOPÁZIO S.A.",
        "Numero_Codigo": "082",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO TOPÁZIO S.A.                                                              ",
        "Início_da_Operação": "12/06/2009"
    },
    {
        "ISPB": 7853842,
        "Nome_Reduzido": "CCR DE OURO",
        "Numero_Codigo": "286",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO                            ",
        "Início_da_Operação": "17/09/2018"
    },
    {
        "ISPB": 7945233,
        "Nome_Reduzido": "POLOCRED SCMEPP LTDA.",
        "Numero_Codigo": "093",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT",
        "Início_da_Operação": "09/11/2010"
    },
    {
        "ISPB": 8240446,
        "Nome_Reduzido": "CCR DE IBIAM",
        "Numero_Codigo": "391",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "COOPERATIVA DE CREDITO RURAL DE IBIAM - SULCREDI/IBIAM                          ",
        "Início_da_Operação": "10/07/2020"
    },
    {
        "ISPB": 8253539,
        "Nome_Reduzido": "CCR DE SÃO MIGUEL DO OESTE",
        "Numero_Codigo": "273",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Cooperativa de Crédito Rural de São Miguel do Oeste - Sulcredi/São Miguel       ",
        "Início_da_Operação": "24/04/2018"
    },
    {
        "ISPB": 8357240,
        "Nome_Reduzido": "BCO CSF S.A.",
        "Numero_Codigo": "368",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco CSF S.A.                                                                  ",
        "Início_da_Operação": "25/05/2020"
    },
    {
        "ISPB": 8561701,
        "Nome_Reduzido": "PAGSEGURO",
        "Numero_Codigo": "290",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Pagseguro Internet S.A.                                                         ",
        "Início_da_Operação": "07/11/2018"
    },
    {
        "ISPB": 8609934,
        "Nome_Reduzido": "MONEYCORP BCO DE CÂMBIO S.A.",
        "Numero_Codigo": "259",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "MONEYCORP BANCO DE CÂMBIO S.A.                                                  ",
        "Início_da_Operação": "27/01/2020"
    },
    {
        "ISPB": 9089356,
        "Nome_Reduzido": "GERENCIANET PAGTOS BRASIL LTDA",
        "Numero_Codigo": "364",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "GERENCIANET PAGAMENTOS DO BRASIL LTDA                                           ",
        "Início_da_Operação": "16/03/2020"
    },
    {
        "ISPB": 9105360,
        "Nome_Reduzido": "ICAP DO BRASIL CTVM LTDA.",
        "Numero_Codigo": "157",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.                 ",
        "Início_da_Operação": "12/02/2016"
    },
    {
        "ISPB": 9210106,
        "Nome_Reduzido": "SOCRED SA - SCMEPP",
        "Numero_Codigo": "183",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "SOCRED S.A. - SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P",
        "Início_da_Operação": "12/06/2017"
    },
    {
        "ISPB": 9274232,
        "Nome_Reduzido": "STATE STREET BR S.A. BCO COMERCIAL",
        "Numero_Codigo": "014",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "STATE STREET BRASIL S.A. ? BANCO COMERCIAL                                      ",
        "Início_da_Operação": "08/08/2008"
    },
    {
        "ISPB": 9313766,
        "Nome_Reduzido": "CARUANA SCFI",
        "Numero_Codigo": "130",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CARUANA S.A. - SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO               ",
        "Início_da_Operação": "12/08/2013"
    },
    {
        "ISPB": 9512542,
        "Nome_Reduzido": "CODEPE CVC S.A.",
        "Numero_Codigo": "127",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Codepe Corretora de Valores e Câmbio S.A.                                       ",
        "Início_da_Operação": "09/11/2012"
    },
    {
        "ISPB": 9516419,
        "Nome_Reduzido": "BCO ORIGINAL DO AGRO S/A",
        "Numero_Codigo": "079",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Original do Agronegócio S.A.                                              ",
        "Início_da_Operação": "25/07/2008"
    },
    {
        "ISPB": 9554480,
        "Nome_Reduzido": "SUPER PAGAMENTOS E ADMINISTRACAO DE MEIOS ELETRONICOS S.A.",
        "Numero_Codigo": "340",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Super Pagamentos e Administração de Meios Eletrônicos S.A.                      ",
        "Início_da_Operação": "25/09/2019"
    },
    {
        "ISPB": 10264663,
        "Nome_Reduzido": "BANCOSEGURO S.A.",
        "Numero_Codigo": "081",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BancoSeguro S.A.                                                                ",
        "Início_da_Operação": "24/10/2008"
    },
    {
        "ISPB": 10398952,
        "Nome_Reduzido": "CRESOL CONFEDERAÇÃO",
        "Numero_Codigo": "133",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E",
        "Início_da_Operação": "02/05/2016"
    },
    {
        "ISPB": 10573521,
        "Nome_Reduzido": "MERCADO PAGO",
        "Numero_Codigo": "323",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "MERCADOPAGO.COM REPRESENTACOES LTDA.                                            ",
        "Início_da_Operação": "24/06/2019"
    },
    {
        "ISPB": 10664513,
        "Nome_Reduzido": "BCO AGIBANK S.A.",
        "Numero_Codigo": "121",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Agibank S.A.                                                              ",
        "Início_da_Operação": "04/04/2012"
    },
    {
        "ISPB": 10690848,
        "Nome_Reduzido": "BCO DA CHINA BRASIL S.A.",
        "Numero_Codigo": "083",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco da China Brasil S.A.                                                      ",
        "Início_da_Operação": "14/07/2009"
    },
    {
        "ISPB": 10853017,
        "Nome_Reduzido": "GET MONEY CC LTDA",
        "Numero_Codigo": "138",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Get Money Corretora de Câmbio S.A.                                              ",
        "Início_da_Operação": "14/07/2014"
    },
    {
        "ISPB": 10866788,
        "Nome_Reduzido": "BCO BANDEPE S.A.",
        "Numero_Codigo": "024",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bandepe S.A.                                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 11476673,
        "Nome_Reduzido": "BANCO RANDON S.A.",
        "Numero_Codigo": "088",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO RANDON S.A.                                                               ",
        "Início_da_Operação": "03/08/2020"
    },
    {
        "ISPB": 11495073,
        "Nome_Reduzido": "OM DTVM LTDA",
        "Numero_Codigo": "319",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA                          ",
        "Início_da_Operação": "01/03/2019"
    },
    {
        "ISPB": 11581339,
        "Nome_Reduzido": "MONEY PLUS SCMEPP LTDA",
        "Numero_Codigo": "274",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT",
        "Início_da_Operação": "10/09/2019"
    },
    {
        "ISPB": 11703662,
        "Nome_Reduzido": "TRAVELEX BANCO DE CÂMBIO S.A.",
        "Numero_Codigo": "095",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Travelex Banco de Câmbio S.A.                                                   ",
        "Início_da_Operação": "22/06/2010"
    },
    {
        "ISPB": 11758741,
        "Nome_Reduzido": "BANCO FINAXIS",
        "Numero_Codigo": "094",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Finaxis S.A.                                                              ",
        "Início_da_Operação": "23/08/2010"
    },
    {
        "ISPB": 11970623,
        "Nome_Reduzido": "SENFF S.A. - CFI",
        "Numero_Codigo": "276",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Senff S.A. - Crédito, Financiamento e Investimento                              ",
        "Início_da_Operação": "12/06/2018"
    },
    {
        "ISPB": 12865507,
        "Nome_Reduzido": "BRK S.A. CFI",
        "Numero_Codigo": "092",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BRK S.A. Crédito, Financiamento e Investimento                                  ",
        "Início_da_Operação": "01/07/2010"
    },
    {
        "ISPB": 13009717,
        "Nome_Reduzido": "BCO DO EST. DE SE S.A.",
        "Numero_Codigo": "047",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco do Estado de Sergipe S.A.                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 13059145,
        "Nome_Reduzido": "BEXS BCO DE CAMBIO S.A.",
        "Numero_Codigo": "144",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BEXS BANCO DE CÂMBIO S/A                                                        ",
        "Início_da_Operação": "23/05/2016"
    },
    {
        "ISPB": 13140088,
        "Nome_Reduzido": "ACESSO SOLUCOES PAGAMENTO SA",
        "Numero_Codigo": "332",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Acesso Soluções de Pagamento S.A.                                               ",
        "Início_da_Operação": "16/08/2019"
    },
    {
        "ISPB": 13220493,
        "Nome_Reduzido": "BR PARTNERS BI",
        "Numero_Codigo": "126",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BR Partners Banco de Investimento S.A.                                          ",
        "Início_da_Operação": "04/01/2013"
    },
    {
        "ISPB": 13293225,
        "Nome_Reduzido": "ÓRAMA DTVM S.A.",
        "Numero_Codigo": "325",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Órama Distribuidora de Títulos e Valores Mobiliários S.A.                       ",
        "Início_da_Operação": "31/05/2019"
    },
    {
        "ISPB": 13370835,
        "Nome_Reduzido": "BPP IP S.A.",
        "Numero_Codigo": "301",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BPP Instituição de Pagamento S.A.                                               ",
        "Início_da_Operação": "26/09/2018"
    },
    {
        "ISPB": 13486793,
        "Nome_Reduzido": "BRL TRUST DTVM SA",
        "Numero_Codigo": "173",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.                   ",
        "Início_da_Operação": "28/11/2016"
    },
    {
        "ISPB": 13673855,
        "Nome_Reduzido": "FRAM CAPITAL DTVM S.A.",
        "Numero_Codigo": "331",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.                ",
        "Início_da_Operação": "27/09/2019"
    },
    {
        "ISPB": 13720915,
        "Nome_Reduzido": "BCO WESTERN UNION",
        "Numero_Codigo": "119",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Western Union do Brasil S.A.                                              ",
        "Início_da_Operação": "10/10/2011"
    },
    {
        "ISPB": 14190547,
        "Nome_Reduzido": "CAMBIONET CC LTDA",
        "Numero_Codigo": "309",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "CAMBIONET CORRETORA DE CÂMBIO LTDA.                                             ",
        "Início_da_Operação": "21/11/2018"
    },
    {
        "ISPB": 14388334,
        "Nome_Reduzido": "PARANA BCO S.A.",
        "Numero_Codigo": "254",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PARANÁ BANCO S.A.                                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 14511781,
        "Nome_Reduzido": "BARI CIA HIPOTECÁRIA",
        "Numero_Codigo": "268",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "BARI COMPANHIA HIPOTECÁRIA                                                      ",
        "Início_da_Operação": "21/12/2017"
    },
    {
        "ISPB": 15114366,
        "Nome_Reduzido": "BCO BOCOM BBM S.A.",
        "Numero_Codigo": "107",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bocom BBM S.A.                                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 15173776,
        "Nome_Reduzido": "BCO CAPITAL S.A.",
        "Numero_Codigo": "412",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO CAPITAL S.A.                                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 15357060,
        "Nome_Reduzido": "BCO WOORI BANK DO BRASIL S.A.",
        "Numero_Codigo": "124",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Woori Bank do Brasil S.A.                                                 ",
        "Início_da_Operação": "09/08/2012"
    },
    {
        "ISPB": 15581638,
        "Nome_Reduzido": "FACTA S.A. CFI",
        "Numero_Codigo": "149",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Facta Financeira S.A. - Crédito Financiamento e Investimento                    ",
        "Início_da_Operação": "08/07/2015"
    },
    {
        "ISPB": 16501555,
        "Nome_Reduzido": "STONE PAGAMENTOS S.A.",
        "Numero_Codigo": "197",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Stone Pagamentos S.A.                                                           ",
        "Início_da_Operação": "18/10/2017"
    },
    {
        "ISPB": 16944141,
        "Nome_Reduzido": "BROKER BRASIL CC LTDA.",
        "Numero_Codigo": "142",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Broker Brasil Corretora de Câmbio Ltda.                                         ",
        "Início_da_Operação": "23/06/2015"
    },
    {
        "ISPB": 17184037,
        "Nome_Reduzido": "BCO MERCANTIL DO BRASIL S.A.",
        "Numero_Codigo": "389",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Mercantil do Brasil S.A.                                                  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 17298092,
        "Nome_Reduzido": "BCO ITAÚ BBA S.A.",
        "Numero_Codigo": "184",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Itaú BBA S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 17351180,
        "Nome_Reduzido": "BCO TRIANGULO S.A.",
        "Numero_Codigo": "634",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO TRIANGULO S.A.                                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 17352220,
        "Nome_Reduzido": "SENSO CCVM S.A.",
        "Numero_Codigo": "545",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A                             ",
        "Início_da_Operação": "27/09/2010"
    },
    {
        "ISPB": 17453575,
        "Nome_Reduzido": "ICBC DO BRASIL BM S.A.",
        "Numero_Codigo": "132",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "ICBC do Brasil Banco Múltiplo S.A.                                              ",
        "Início_da_Operação": "26/09/2013"
    },
    {
        "ISPB": 17772370,
        "Nome_Reduzido": "VIPS CC LTDA.",
        "Numero_Codigo": "298",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Vip's Corretora de Câmbio Ltda.                                                 ",
        "Início_da_Operação": "15/08/2018"
    },
    {
        "ISPB": 18188384,
        "Nome_Reduzido": "CREFAZ SCMEPP LTDA",
        "Numero_Codigo": "321",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT",
        "Início_da_Operação": "11/06/2019"
    },
    {
        "ISPB": 18236120,
        "Nome_Reduzido": "NU PAGAMENTOS S.A.",
        "Numero_Codigo": "260",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Nu Pagamentos S.A.                                                              ",
        "Início_da_Operação": "10/10/2017"
    },
    {
        "ISPB": 18520834,
        "Nome_Reduzido": "UBS BRASIL BI S.A.",
        "Numero_Codigo": "129",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "UBS Brasil Banco de Investimento S.A.                                           ",
        "Início_da_Operação": "12/03/2014"
    },
    {
        "ISPB": 19307785,
        "Nome_Reduzido": "MS BANK S.A. BCO DE CÂMBIO",
        "Numero_Codigo": "128",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "MS Bank S.A. Banco de Câmbio                                                    ",
        "Início_da_Operação": "27/04/2015"
    },
    {
        "ISPB": 20155248,
        "Nome_Reduzido": "PARMETAL DTVM LTDA",
        "Numero_Codigo": "194",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA                    ",
        "Início_da_Operação": "25/10/2017"
    },
    {
        "ISPB": 21018182,
        "Nome_Reduzido": "JUNO",
        "Numero_Codigo": "383",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.                               ",
        "Início_da_Operação": "09/07/2020"
    },
    {
        "ISPB": 22610500,
        "Nome_Reduzido": "VORTX DTVM LTDA.",
        "Numero_Codigo": "310",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.                      ",
        "Início_da_Operação": "18/10/2018"
    },
    {
        "ISPB": 23522214,
        "Nome_Reduzido": "COMMERZBANK BRASIL S.A. - BCO MÚLTIPLO",
        "Numero_Codigo": "163",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Commerzbank Brasil S.A. - Banco Múltiplo                                        ",
        "Início_da_Operação": "10/08/2016"
    },
    {
        "ISPB": 23862762,
        "Nome_Reduzido": "AVISTA S.A. CFI",
        "Numero_Codigo": "280",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Avista S.A. Crédito, Financiamento e Investimento                               ",
        "Início_da_Operação": "10/05/2018"
    },
    {
        "ISPB": 24074692,
        "Nome_Reduzido": "GUITTA CC LTDA",
        "Numero_Codigo": "146",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "GUITTA CORRETORA DE CAMBIO LTDA.                                                ",
        "Início_da_Operação": "20/05/2015"
    },
    {
        "ISPB": 24537861,
        "Nome_Reduzido": "FFA SCMEPP LTDA.",
        "Numero_Codigo": "343",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.",
        "Início_da_Operação": "12/11/2019"
    },
    {
        "ISPB": 26563270,
        "Nome_Reduzido": "CCR DE PRIMAVERA DO LESTE",
        "Numero_Codigo": "279",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE                              ",
        "Início_da_Operação": "05/06/2018"
    },
    {
        "ISPB": 27098060,
        "Nome_Reduzido": "BANCO DIGIO",
        "Numero_Codigo": "335",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Digio S.A.                                                                ",
        "Início_da_Operação": "25/11/2019"
    },
    {
        "ISPB": 27214112,
        "Nome_Reduzido": "AMAGGI S.A. CFI",
        "Numero_Codigo": "349",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "AMAGGI S.A. - CRÉDITO, FINANCIAMENTO E INVESTIMENTO                             ",
        "Início_da_Operação": "24/10/2019"
    },
    {
        "ISPB": 27652684,
        "Nome_Reduzido": "GENIAL INVESTIMENTOS CVM S.A.",
        "Numero_Codigo": "278",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Genial Investimentos Corretora de Valores Mobiliários S.A.                      ",
        "Início_da_Operação": "14/05/2018"
    },
    {
        "ISPB": 27842177,
        "Nome_Reduzido": "IB CCTVM S.A.",
        "Numero_Codigo": "271",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.                      ",
        "Início_da_Operação": "26/02/2018"
    },
    {
        "ISPB": 28127603,
        "Nome_Reduzido": "BCO BANESTES S.A.",
        "Numero_Codigo": "021",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 28195667,
        "Nome_Reduzido": "BCO ABC BRASIL S.A.",
        "Numero_Codigo": "246",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco ABC Brasil S.A.                                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 28650236,
        "Nome_Reduzido": "BS2 DTVM S.A.",
        "Numero_Codigo": "292",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BS2 Distribuidora de Títulos e Valores Mobiliários S.A.                         ",
        "Início_da_Operação": "24/10/2018"
    },
    {
        "ISPB": 28719664,
        "Nome_Reduzido": "B3 Cetip                           ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "B3 SA - Brasil, Bolsa, Balcão - Segmento Cetip UTVM                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 29011780,
        "Nome_Reduzido": "CIP C3                             ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Câmara Interbancária de Pagamentos - CIP C3                                     ",
        "Início_da_Operação": "30/01/2012"
    },
    {
        "ISPB": 29030467,
        "Nome_Reduzido": "SCOTIABANK BRASIL",
        "Numero_Codigo": "751",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Scotiabank Brasil S.A. Banco Múltiplo                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 29162769,
        "Nome_Reduzido": "TORO CTVM LTDA",
        "Numero_Codigo": "352",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA                            ",
        "Início_da_Operação": "29/11/2019"
    },
    {
        "ISPB": 30306294,
        "Nome_Reduzido": "BANCO BTG PACTUAL S.A.",
        "Numero_Codigo": "208",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco BTG Pactual S.A.                                                          ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 30723886,
        "Nome_Reduzido": "BCO MODAL S.A.",
        "Numero_Codigo": "746",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Modal S.A.                                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 31597552,
        "Nome_Reduzido": "BCO CLASSICO S.A.",
        "Numero_Codigo": "241",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO CLASSICO S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 31872495,
        "Nome_Reduzido": "BCO C6 S.A.",
        "Numero_Codigo": "336",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco C6 S.A.                                                                   ",
        "Início_da_Operação": "31/01/2019"
    },
    {
        "ISPB": 31880826,
        "Nome_Reduzido": "BCO GUANABARA S.A.",
        "Numero_Codigo": "612",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Guanabara S.A.                                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 31895683,
        "Nome_Reduzido": "BCO INDUSTRIAL DO BRASIL S.A.",
        "Numero_Codigo": "604",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Industrial do Brasil S.A.                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 32062580,
        "Nome_Reduzido": "BCO CREDIT SUISSE S.A.",
        "Numero_Codigo": "505",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Credit Suisse (Brasil) S.A.                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 32402502,
        "Nome_Reduzido": "QI SCD S.A.",
        "Numero_Codigo": "329",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "QI Sociedade de Crédito Direto S.A.                                             ",
        "Início_da_Operação": "30/04/2019"
    },
    {
        "ISPB": 32648370,
        "Nome_Reduzido": "FAIR CC S.A.",
        "Numero_Codigo": "196",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "FAIR CORRETORA DE CAMBIO S.A.                                                   ",
        "Início_da_Operação": "11/09/2017"
    },
    {
        "ISPB": 32997490,
        "Nome_Reduzido": "CREDITAS SCD",
        "Numero_Codigo": "342",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Creditas Sociedade de Crédito Direto S.A.                                       ",
        "Início_da_Operação": "26/07/2019"
    },
    {
        "ISPB": 33042151,
        "Nome_Reduzido": "BCO LA NACION ARGENTINA",
        "Numero_Codigo": "300",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco de la Nacion Argentina                                                    ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33042953,
        "Nome_Reduzido": "CITIBANK N.A.",
        "Numero_Codigo": "477",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Citibank N.A.                                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33132044,
        "Nome_Reduzido": "BCO CEDULA S.A.",
        "Numero_Codigo": "266",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO CEDULA S.A.                                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33147315,
        "Nome_Reduzido": "BCO BRADESCO BERJ S.A.",
        "Numero_Codigo": "122",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bradesco BERJ S.A.                                                        ",
        "Início_da_Operação": "08/11/2011"
    },
    {
        "ISPB": 33172537,
        "Nome_Reduzido": "BCO J.P. MORGAN S.A.",
        "Numero_Codigo": "376",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO J.P. MORGAN S.A.                                                          ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33264668,
        "Nome_Reduzido": "BCO XP S.A.",
        "Numero_Codigo": "348",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco XP S.A.                                                                   ",
        "Início_da_Operação": "01/11/2019"
    },
    {
        "ISPB": 33466988,
        "Nome_Reduzido": "BCO CAIXA GERAL BRASIL S.A.",
        "Numero_Codigo": "473",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Caixa Geral - Brasil S.A.                                                 ",
        "Início_da_Operação": "31/03/2009"
    },
    {
        "ISPB": 33479023,
        "Nome_Reduzido": "BCO CITIBANK S.A.",
        "Numero_Codigo": "745",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Citibank S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33603457,
        "Nome_Reduzido": "BCO RODOBENS S.A.",
        "Numero_Codigo": "120",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO RODOBENS S.A.                                                             ",
        "Início_da_Operação": "06/02/2012"
    },
    {
        "ISPB": 33644196,
        "Nome_Reduzido": "BCO FATOR S.A.",
        "Numero_Codigo": "265",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Fator S.A.                                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33657248,
        "Nome_Reduzido": "BNDES",
        "Numero_Codigo": "007",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL                            ",
        "Início_da_Operação": "30/06/2014"
    },
    {
        "ISPB": 33775974,
        "Nome_Reduzido": "ATIVA S.A. INVESTIMENTOS CCTVM",
        "Numero_Codigo": "188",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS, CÂMBIO E VALORES                 ",
        "Início_da_Operação": "28/07/2017"
    },
    {
        "ISPB": 33862244,
        "Nome_Reduzido": "BGC LIQUIDEZ DTVM LTDA",
        "Numero_Codigo": "134",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA                ",
        "Início_da_Operação": "28/07/2014"
    },
    {
        "ISPB": 33885724,
        "Nome_Reduzido": "BANCO ITAÚ CONSIGNADO S.A.",
        "Numero_Codigo": "029",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Itaú Consignado S.A.                                                      ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 33923798,
        "Nome_Reduzido": "BCO MÁXIMA S.A.",
        "Numero_Codigo": "243",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Máxima S.A.                                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 34111187,
        "Nome_Reduzido": "HAITONG BI DO BRASIL S.A.",
        "Numero_Codigo": "078",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Haitong Banco de Investimento do Brasil S.A.                                    ",
        "Início_da_Operação": "31/07/2008"
    },
    {
        "ISPB": 34335592,
        "Nome_Reduzido": "ÓTIMO SCD S.A.",
        "Numero_Codigo": "355",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.                                          ",
        "Início_da_Operação": "21/10/2019"
    },
    {
        "ISPB": 34711571,
        "Nome_Reduzido": "VITREO DTVM S.A.",
        "Numero_Codigo": "367",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.                      ",
        "Início_da_Operação": "12/03/2020"
    },
    {
        "ISPB": 35977097,
        "Nome_Reduzido": "UP.P SEP S.A.",
        "Numero_Codigo": "373",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.                                 ",
        "Início_da_Operação": "25/03/2020"
    },
    {
        "ISPB": 36113876,
        "Nome_Reduzido": "OLIVEIRA TRUST DTVM S.A.",
        "Numero_Codigo": "111",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.              ",
        "Início_da_Operação": "24/03/2011"
    },
    {
        "ISPB": 40303299,
        "Nome_Reduzido": "PORTOPAR DTVM LTDA",
        "Numero_Codigo": "306",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.                   ",
        "Início_da_Operação": "06/02/2019"
    },
    {
        "ISPB": 42272526,
        "Nome_Reduzido": "BNY MELLON BCO S.A.",
        "Numero_Codigo": "017",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BNY Mellon Banco S.A.                                                           ",
        "Início_da_Operação": "19/11/2012"
    },
    {
        "ISPB": 43180355,
        "Nome_Reduzido": "PERNAMBUCANAS FINANC S.A. CFI",
        "Numero_Codigo": "174",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "PERNAMBUCANAS FINANCIADORA S.A. - CRÉDITO, FINANCIAMENTO E INVESTIMENTO         ",
        "Início_da_Operação": "21/11/2017"
    },
    {
        "ISPB": 44189447,
        "Nome_Reduzido": "BCO LA PROVINCIA B AIRES BCE",
        "Numero_Codigo": "495",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco de La Provincia de Buenos Aires                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 45246410,
        "Nome_Reduzido": "PLURAL BCO BM",
        "Numero_Codigo": "125",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Plural S.A. Banco Múltiplo                                                      ",
        "Início_da_Operação": "19/11/2012"
    },
    {
        "ISPB": 46518205,
        "Nome_Reduzido": "JPMORGAN CHASE BANK",
        "Numero_Codigo": "488",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "JPMorgan Chase Bank, National Association                                       ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 48795256,
        "Nome_Reduzido": "BCO ANDBANK S.A.",
        "Numero_Codigo": "065",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco AndBank (Brasil) S.A.                                                     ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 49336860,
        "Nome_Reduzido": "ING BANK N.V.",
        "Numero_Codigo": "492",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "ING Bank N.V.                                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 50579044,
        "Nome_Reduzido": "LEVYCAM CCV LTDA",
        "Numero_Codigo": "145",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "LEVYCAM - CORRETORA DE CAMBIO E VALORES LTDA.                                   ",
        "Início_da_Operação": "16/06/2015"
    },
    {
        "ISPB": 50585090,
        "Nome_Reduzido": "BCV",
        "Numero_Codigo": "250",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BCV - BANCO DE CRÉDITO E VAREJO S.A.                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 52904364,
        "Nome_Reduzido": "NECTON INVESTIMENTOS S.A CVM",
        "Numero_Codigo": "354",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES       ",
        "Início_da_Operação": "30/10/2019"
    },
    {
        "ISPB": 52937216,
        "Nome_Reduzido": "BEXS CC S.A.",
        "Numero_Codigo": "253",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Bexs Corretora de Câmbio S/A                                                    ",
        "Início_da_Operação": "11/11/2016"
    },
    {
        "ISPB": 53518684,
        "Nome_Reduzido": "BCO HSBC S.A.",
        "Numero_Codigo": "269",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO HSBC S.A.                                                                 ",
        "Início_da_Operação": "07/02/2018"
    },
    {
        "ISPB": 54403563,
        "Nome_Reduzido": "BCO ARBI S.A.",
        "Numero_Codigo": "213",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Arbi S.A.                                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 54641030,
        "Nome_Reduzido": "BMFBOVESPA                         ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BMF Bovespa S.A. - Bolsa de Valores, Mercadorias e Futuros - Camara BMFBOVESPA  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 55230916,
        "Nome_Reduzido": "INTESA SANPAOLO BRASIL S.A. BM",
        "Numero_Codigo": "139",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Intesa Sanpaolo Brasil S.A. - Banco Múltiplo                                    ",
        "Início_da_Operação": "08/05/2015"
    },
    {
        "ISPB": 57839805,
        "Nome_Reduzido": "BCO TRICURY S.A.",
        "Numero_Codigo": "018",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Tricury S.A.                                                              ",
        "Início_da_Operação": "05/08/2013"
    },
    {
        "ISPB": 58160789,
        "Nome_Reduzido": "BCO SAFRA S.A.",
        "Numero_Codigo": "422",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Safra S.A.                                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 58497702,
        "Nome_Reduzido": "SMARTBANK",
        "Numero_Codigo": "630",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Smartbank S.A.                                                            ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 58616418,
        "Nome_Reduzido": "BCO FIBRA S.A.",
        "Numero_Codigo": "224",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Fibra S.A.                                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 59118133,
        "Nome_Reduzido": "BCO LUSO BRASILEIRO S.A.",
        "Numero_Codigo": "600",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Luso Brasileiro S.A.                                                      ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 59274605,
        "Nome_Reduzido": "BCO GM S.A.",
        "Numero_Codigo": "390",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO GM S.A.                                                                   ",
        "Início_da_Operação": "22/07/2020"
    },
    {
        "ISPB": 59285411,
        "Nome_Reduzido": "BANCO PAN",
        "Numero_Codigo": "623",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Pan S.A.                                                                  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 59588111,
        "Nome_Reduzido": "BCO VOTORANTIM S.A.",
        "Numero_Codigo": "655",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Votorantim S.A.                                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60394079,
        "Nome_Reduzido": "BCO ITAUBANK S.A.",
        "Numero_Codigo": "479",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco ItauBank S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60498557,
        "Nome_Reduzido": "BCO MUFG BRASIL S.A.",
        "Numero_Codigo": "456",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco MUFG Brasil S.A.                                                          ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60518222,
        "Nome_Reduzido": "BCO SUMITOMO MITSUI BRASIL S.A.",
        "Numero_Codigo": "464",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Sumitomo Mitsui Brasileiro S.A.                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60701190,
        "Nome_Reduzido": "ITAÚ UNIBANCO S.A.",
        "Numero_Codigo": "341",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "ITAÚ UNIBANCO S.A.                                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60746948,
        "Nome_Reduzido": "BCO BRADESCO S.A.",
        "Numero_Codigo": "237",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Bradesco S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60814191,
        "Nome_Reduzido": "BCO MERCEDES-BENZ S.A.",
        "Numero_Codigo": "381",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO MERCEDES-BENZ DO BRASIL S.A.                                              ",
        "Início_da_Operação": "25/05/2020"
    },
    {
        "ISPB": 60850229,
        "Nome_Reduzido": "OMNI BANCO S.A.",
        "Numero_Codigo": "613",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Omni Banco S.A.                                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60872504,
        "Nome_Reduzido": "ITAÚ UNIBANCO HOLDING S.A.",
        "Numero_Codigo": "652",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Itaú Unibanco Holding S.A.                                                      ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60889128,
        "Nome_Reduzido": "BCO SOFISA S.A.",
        "Numero_Codigo": "637",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO SOFISA S.A.                                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 60934221,
        "Nome_Reduzido": "BMF Câmbio                         ",
        "Numero_Codigo": "n/a",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BMF Bovespa S/A - Bolsa de Valores, Mercadorias e Futuros - Camara Cambio       ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61024352,
        "Nome_Reduzido": "BCO INDUSVAL S.A.",
        "Numero_Codigo": "653",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO INDUSVAL S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61033106,
        "Nome_Reduzido": "BCO CREFISA S.A.",
        "Numero_Codigo": "069",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Crefisa S.A.                                                              ",
        "Início_da_Operação": "18/11/2005"
    },
    {
        "ISPB": 61088183,
        "Nome_Reduzido": "BCO MIZUHO S.A.",
        "Numero_Codigo": "370",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Mizuho do Brasil S.A.                                                     ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61182408,
        "Nome_Reduzido": "BANCO INVESTCRED UNIBANCO S.A.",
        "Numero_Codigo": "249",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Investcred Unibanco S.A.                                                  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61186680,
        "Nome_Reduzido": "BCO BMG S.A.",
        "Numero_Codigo": "318",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco BMG S.A.                                                                  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61348538,
        "Nome_Reduzido": "BCO FICSA S.A.",
        "Numero_Codigo": "626",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO FICSA S.A.                                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61444949,
        "Nome_Reduzido": "SAGITUR CC LTDA",
        "Numero_Codigo": "270",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Sagitur Corretora de Câmbio Ltda.                                               ",
        "Início_da_Operação": "01/08/2018"
    },
    {
        "ISPB": 61533584,
        "Nome_Reduzido": "BCO SOCIETE GENERALE BRASIL",
        "Numero_Codigo": "366",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO SOCIETE GENERALE BRASIL S.A.                                              ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 61723847,
        "Nome_Reduzido": "MAGLIANO S.A. CCVM",
        "Numero_Codigo": "113",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Magliano S.A. Corretora de Cambio e Valores Mobiliarios                         ",
        "Início_da_Operação": "28/11/2011"
    },
    {
        "ISPB": 61747085,
        "Nome_Reduzido": "TULLETT PREBON BRASIL CVC LTDA",
        "Numero_Codigo": "131",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA                        ",
        "Início_da_Operação": "15/07/2013"
    },
    {
        "ISPB": 61809182,
        "Nome_Reduzido": "C.SUISSE HEDGING-GRIFFO CV S/A",
        "Numero_Codigo": "011",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A                           ",
        "Início_da_Operação": "28/06/2011"
    },
    {
        "ISPB": 61820817,
        "Nome_Reduzido": "BCO PAULISTA S.A.",
        "Numero_Codigo": "611",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Paulista S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 62073200,
        "Nome_Reduzido": "BOFA MERRILL LYNCH BM S.A.",
        "Numero_Codigo": "755",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Bank of America Merrill Lynch Banco Múltiplo S.A.                               ",
        "Início_da_Operação": "09/11/2007"
    },
    {
        "ISPB": 62109566,
        "Nome_Reduzido": "CREDISAN CC",
        "Numero_Codigo": "089",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CREDISAN COOPERATIVA DE CRÉDITO                                                 ",
        "Início_da_Operação": "30/08/2010"
    },
    {
        "ISPB": 62144175,
        "Nome_Reduzido": "BCO PINE S.A.",
        "Numero_Codigo": "643",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Pine S.A.                                                                 ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 62169875,
        "Nome_Reduzido": "EASYNVEST - TÍTULO CV SA",
        "Numero_Codigo": "140",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Easynvest - Título Corretora de Valores SA                                      ",
        "Início_da_Operação": "26/05/2015"
    },
    {
        "ISPB": 62232889,
        "Nome_Reduzido": "BCO DAYCOVAL S.A",
        "Numero_Codigo": "707",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Daycoval S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 62237649,
        "Nome_Reduzido": "CAROL DTVM LTDA.",
        "Numero_Codigo": "288",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.                      ",
        "Início_da_Operação": "05/07/2018"
    },
    {
        "ISPB": 62285390,
        "Nome_Reduzido": "SOCOPA SC PAULISTA S.A.",
        "Numero_Codigo": "363",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "SOCOPA SOCIEDADE CORRETORA PAULISTA S.A.                                        ",
        "Início_da_Operação": "01/06/2020"
    },
    {
        "ISPB": 62287735,
        "Nome_Reduzido": "RENASCENCA DTVM LTDA",
        "Numero_Codigo": "101",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA                  ",
        "Início_da_Operação": "22/04/2010"
    },
    {
        "ISPB": 62331228,
        "Nome_Reduzido": "DEUTSCHE BANK S.A.BCO ALEMAO",
        "Numero_Codigo": "487",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "DEUTSCHE BANK S.A. - BANCO ALEMAO                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 62421979,
        "Nome_Reduzido": "BANCO CIFRA",
        "Numero_Codigo": "233",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Cifra S.A.                                                                ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 65913436,
        "Nome_Reduzido": "GUIDE",
        "Numero_Codigo": "177",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Guide Investimentos S.A. Corretora de Valores                                   ",
        "Início_da_Operação": "08/05/2017"
    },
    {
        "ISPB": 68757681,
        "Nome_Reduzido": "SOLIDUS S.A. CCVM",
        "Numero_Codigo": "365",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS                          ",
        "Início_da_Operação": "17/03/2020"
    },
    {
        "ISPB": 68900810,
        "Nome_Reduzido": "BCO RENDIMENTO S.A.",
        "Numero_Codigo": "633",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Rendimento S.A.                                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 71027866,
        "Nome_Reduzido": "BCO BS2 S.A.",
        "Numero_Codigo": "218",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco BS2 S.A.                                                                  ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 71371686,
        "Nome_Reduzido": "BCO OLÉ CONSIGNADO S.A.",
        "Numero_Codigo": "169",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO OLÉ CONSIGNADO S.A.                                                       ",
        "Início_da_Operação": "16/11/2016"
    },
    {
        "ISPB": 71590442,
        "Nome_Reduzido": "LASTRO RDV DTVM LTDA",
        "Numero_Codigo": "293",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.                 ",
        "Início_da_Operação": "10/09/2018"
    },
    {
        "ISPB": 71677850,
        "Nome_Reduzido": "FRENTE CC LTDA.",
        "Numero_Codigo": "285",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Frente Corretora de Câmbio Ltda.                                                ",
        "Início_da_Operação": "25/09/2018"
    },
    {
        "ISPB": 73622748,
        "Nome_Reduzido": "B&T CC LTDA.",
        "Numero_Codigo": "080",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "B&T CORRETORA DE CAMBIO LTDA.                                                   ",
        "Início_da_Operação": "18/11/2010"
    },
    {
        "ISPB": 74828799,
        "Nome_Reduzido": "NOVO BCO CONTINENTAL S.A. - BM",
        "Numero_Codigo": "753",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Novo Banco Continental S.A. - Banco Múltiplo                                    ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 75647891,
        "Nome_Reduzido": "BCO CRÉDIT AGRICOLE BR S.A.",
        "Numero_Codigo": "222",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO CRÉDIT AGRICOLE BRASIL S.A.                                               ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 76461557,
        "Nome_Reduzido": "CCR COOPAVEL",
        "Numero_Codigo": "281",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Cooperativa de Crédito Rural Coopavel                                           ",
        "Início_da_Operação": "05/11/2018"
    },
    {
        "ISPB": 76543115,
        "Nome_Reduzido": "BANCO SISTEMA",
        "Numero_Codigo": "754",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Sistema S.A.                                                              ",
        "Início_da_Operação": "15/07/2015"
    },
    {
        "ISPB": 78157146,
        "Nome_Reduzido": "CREDIALIANÇA CCR",
        "Numero_Codigo": "098",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Credialiança Cooperativa de Crédito Rural                                       ",
        "Início_da_Operação": "18/01/2011"
    },
    {
        "ISPB": 78626983,
        "Nome_Reduzido": "BCO VR S.A.",
        "Numero_Codigo": "610",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco VR S.A.                                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 78632767,
        "Nome_Reduzido": "BCO OURINVEST S.A.",
        "Numero_Codigo": "712",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Ourinvest S.A.                                                            ",
        "Início_da_Operação": "28/01/2014"
    },
    {
        "ISPB": 81723108,
        "Nome_Reduzido": "CREDICOAMO",
        "Numero_Codigo": "010",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "CREDICOAMO CREDITO RURAL COOPERATIVA                                            ",
        "Início_da_Operação": "10/12/2012"
    },
    {
        "ISPB": 89960090,
        "Nome_Reduzido": "RB CAPITAL INVESTIMENTOS DTVM LTDA.",
        "Numero_Codigo": "283",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "RB CAPITAL INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LIMITADA",
        "Início_da_Operação": "05/07/2018"
    },
    {
        "ISPB": 90400888,
        "Nome_Reduzido": "BCO SANTANDER (BRASIL) S.A.",
        "Numero_Codigo": "033",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO SANTANDER (BRASIL) S.A.                                                   ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 91884981,
        "Nome_Reduzido": "BANCO JOHN DEERE S.A.",
        "Numero_Codigo": "217",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco John Deere S.A.                                                           ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 92702067,
        "Nome_Reduzido": "BCO DO ESTADO DO RS S.A.",
        "Numero_Codigo": "041",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco do Estado do Rio Grande do Sul S.A.                                       ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 92856905,
        "Nome_Reduzido": "ADVANCED CC LTDA",
        "Numero_Codigo": "117",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "ADVANCED CORRETORA DE CÂMBIO LTDA                                               ",
        "Início_da_Operação": "03/10/2011"
    },
    {
        "ISPB": 92874270,
        "Nome_Reduzido": "BCO DIGIMAIS S.A.",
        "Numero_Codigo": "654",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "BANCO DIGIMAIS S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 92875780,
        "Nome_Reduzido": "WARREN CVMC LTDA",
        "Numero_Codigo": "371",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.                          ",
        "Início_da_Operação": "13/05/2020"
    },
    {
        "ISPB": 92894922,
        "Nome_Reduzido": "BANCO ORIGINAL",
        "Numero_Codigo": "212",
        "Participa_da_Compe": "Sim",
        "Acesso_Principal": "RSFN",
        "Nome_Extenso": "Banco Original S.A.                                                             ",
        "Início_da_Operação": "22/04/2002"
    },
    {
        "ISPB": 94968518,
        "Nome_Reduzido": "DECYSEO CC LTDA.",
        "Numero_Codigo": "289",
        "Participa_da_Compe": "Não",
        "Acesso_Principal": "Internet",
        "Nome_Extenso": "DECYSEO CORRETORA DE CAMBIO LTDA.                                               ",
        "Início_da_Operação": "14/03/2019"
    }
]
